import axios from '../../service/index'
import React, { Component } from 'react'
import { Button, Divider, Table, Modal, message, Switch, Pagination,InputNumber,  DatePicker, TimePicker, Form, Input, Select } from 'antd'
import Wangeditor from '../../commponents/wangeditor/index'
import UploadQiniu from '../../commponents/uploadQiniu/index'
import moment from 'moment';
import "./index.less"

const { RangePicker } = DatePicker;
const FormItem = Form.Item;
const { Option } = Select;

class BootCampet extends Component {
	constructor(props) {
		super(props)
		this.state = {
			total: 0,
			modelTitle: '新增',
			releaseVisible: false,
      visible: false,
      swiperName: '',
      swiperId: '',
      presetNum: 0,
      startDate: '',
      endDate: '',
      startTime: null,
      endTime: null,
      poster: null,
      qiuniuUrl: '',
      searchData: {
        name: '',
        subjectId: '',
      },
      bootListData: [],
      subjectList: [],
      pageNum: 1,
      pageSize: 10,
      bootCampId: '',
      boototal: 0,
      introduce: '',
      columns: [{
					title: '名称',
					dataIndex: 'name',
					key: 'name',
					align: 'center'
				},{
					title: '学科',
					dataIndex: 'subjectName',
					key: 'subjectName',
					align: 'center'
				},{
					title: '开始日期',
					dataIndex: 'startDate',
					key: 'startDate',
					align: 'center'
				},{
					title: '截止日期',
					dataIndex: 'endDate',
					key: 'endDate',
					align: 'center'
				},{
					title: '开始时间',
					dataIndex: 'startTime',
					key: 'startTime',
					align: 'center'
				},{
					title: '截止时间',
					dataIndex: 'endTime',
					key: 'endTime',
					align: 'center'
				},{
					title: '发布状态',
					dataIndex: 'status',
					key: 'status',
					align: 'center',
					width: '90px',
					render: (record,text) => {
						return (
							<div>
								<Switch defaultChecked={record === 1 ? true : false} key={record === 1 ? true : false} onChange={(checked) => {
									 let id = text.id
									 let arr = this.state.bootListData
									for(let i = 0; i<arr.length; i++){
										if(id === arr[i].id){
											arr[i].status = checked===true? 1: 0
											this.setState({
												bootListData: arr
											})
										}
									}
									return (
										Modal.confirm({
											title: `${checked === true ? '发布' : '取消发布'}`,
											okText: "确定",
											cancelText: "取消",
											content: (
												<div>
													<p>{checked === true ? '发布后将同步至用户端，请谨慎操作！确定要发布吗？' : '取消发布后用户端将无法学习，请谨慎操作！确定要取消发布吗？'}</p>
												</div>
											),
											onOk: () => {
												this.isRelease(id,checked,'ok')
											},
											onCancel: () => {
												this.isRelease(id,checked,'cancel')
											}
										})
									)
								}} />

							</div>
						)
					}
				},
        {
					title: '操作',
					key: 'operation',
					align: 'center',
					render: (record) => <div>
						<span style={{ marginRight: '15px', color: '#277FFF', cursor: 'pointer' }} onClick={() => {
							this.setState({
								swiperId: record.id,
								visible: true,
								modelTitle: '编辑',
								swiperName: record.name,
                introduce: record.introduce,
                subjectform: record.subjectId,
                presetNum: record.presetNum||0,
                startDate: moment(record.startDate),
                endDate: moment(record.endDate),
                startTime: moment(record.startTime, 'HH:mm'),
                endTime: moment(record.endTime, 'HH:mm'),
								poster: {
									uid: record.uploadUid,
									type: record.uploadType||'',
									url: record.poster,
									name: record.name
								},
							})
						}}>编辑</span>
						<span style={{ marginRight: '15px', color: '#277FFF', cursor: 'pointer' }} onClick={() => {
							Modal.confirm({
								title: '删除操作',
								okText: "确认",
								cancelText: "取消",
								content: (
									<div>
										<p style={{ whiteSpace: 'nowrap' }}>删除后不可恢复，请谨慎操作！确定要删除吗？</p>
									</div>
								),
								onOk: () => {
									this.delSwiper(record.id)
								},
							});
						}}>删除</span>
            <span style={{ marginRight: '15px', color: '#277FFF', cursor: 'pointer' }} onClick={() => {
              this.props.history.push('/bootVedio', {vedioId: record.id})
						}}>视频详情</span>
            <span style={{  color: '#277FFF', cursor: 'pointer' }} onClick={() => {
							Modal.confirm({
								title: '群发操作',
								okText: "确认",
								cancelText: "取消",
								content: (
									<div>
										<p style={{ whiteSpace: 'nowrap' }}>请谨慎操作！确定要群发吗？</p>
									</div>
								),
								onOk: () => {
									this.sendSwiper(record.id)
								},
							});
						}}>一键群发</span>
					</div>
				}],
    }
  }
showModal() {
  this.setState({visible: true, modelTitle: '新增', introduce: ''})
}
  isRelease = (id, checked, type) => {
    if(checked === 'cancel'){
      this.bootList()
    }else{
      axios.post('bootcamp/updateStatus',{id, status: checked?1:0}).then(res=>{
        if(res.data.code === '200'){
          message.success(`${checked===true?'发布成功':'取消成功'}`)
          this.bootList()
          Modal.destroyAll()
        }else{
          this.bootList()
        }
      })
    }
  }
  bootList = () => {
    axios.post('/bootcamp/list', {
      name: this.state.name,
      subjectId: this.state.subjectId,
      pageNum: this.state.pageNum,
      pageSize: this.state.pageSize
    }).then(res => {
      if(res.data.code === '200'){
        this.setState({
          total: res.data.data.total,
          bootListData: res.data.data.list
        })
      }
      
    })
  }
  sendSwiper = (id) => {
    axios.post('bootcamp/sendSms', {id}).then(res=> {
      if(res.data.code === '200'){
        message.success('群发成功')
        this.bootList()
      }else{
        message.error(res.data.msg)
      }
    })
  }
  delSwiper = (id) => {
    axios.get(`bootcamp/del/${id}`).then(res=> {
      if(res.data.code === '200'){
        message.success('删除成功')
        this.bootList()
      }else{
        message.error(res.data.msg)
      }
    })
  }
  onShowSizeChange = (current,pageSize) => {
    this.setState({
      pageNum: 1,
      pageSize: pageSize
    },()=> {
      this.bootList()
    })
  }
  onChange = (current) => {
    this.setState({
      pageNum: current
    },()=> {
      this.bootList()
    })
  }
  getText = (v, i) => {
		this.props.form.setFieldsValue({
      [`${i}`]: v
		});
	}
  downValidateForm = (rule, value, callback) => {
		if(value&&new Date(value).getTime()<=new Date().getTime()){
			callback('结束时间必须大于现在的时间')
		}else{
			callback()
		}
	}
  getQiniuUrl = v => {
		this.setState({
			qiuniuUrl: v
		})
	}
  subjectList = () => {
    axios.get('subjectController/getOption', {
			...this.state.searchData
		}).then(res => {
			if (res.data.code === '200') {
				this.setState({
					subjectList: res.data.data
				})
			}
		})
  }
  handleOk = ()=> {
		this.props.form.validateFields((err, values) => {
			if(!err) {
				if(this.state.modelTitle === '新增'){
          axios.post('/bootcamp/add',{
            name: values.name,
            subjectId: values.subjectId,
            poster: this.state.qiuniuUrl+'/'+ values.poster.response.key,
            introduce: values.introduce,
            uploadUid: values.poster.uid,
            startDate: values.sleDate[0].format('YYYY-MM-DD'),
            endDate: values.sleDate[1].format('YYYY-MM-DD'),
            startTime: values.startTime.format('HH:mm'),
            endTime: values.endTime.format('HH:mm'),
            presetNum: values.presetNum
          }).then(res => {
            if (res.data.code === '200') {
							message.success('添加成功')
							this.props.form.resetFields();
							this.setState({ visible: false })
							this.bootList()
						}
          })
        }else{
          let pic = values.poster.url&&values.poster.url?values.poster.url:this.state.qiuniuUrl+'/'+values.poster.response.key
          axios.post('/bootcamp/update',{
            id: this.state.swiperId,
            name: values.name,
            subjectId: values.subjectId,
            poster: pic,
            uploadUid: values.poster.uid,
            introduce: values.introduce,
            startDate: values.sleDate[0].format('YYYY-MM-DD'),
            endDate: values.sleDate[1].format('YYYY-MM-DD'),
            startTime: values.startTime.format('HH:mm'),
            endTime: values.endTime.format('HH:mm'),
            presetNum: values.presetNum
          }).then(res => {
            if (res.data.code === '200') {
							message.success('修改成功')
							this.props.form.resetFields();
							this.setState({ visible: false })
							this.bootList()
						} 
          })
        }
      }
    })
  }
  componentDidMount()  {
this.subjectList()
this.bootList()
  }
  render() {
		const {  bootListData, columns, total, name, subjectId, pageNum, subjectform, modelTitle, swiperName, startDate, endDate,startTime,endTime, presetNum, poster, visible, introduce } = this.state;
		const { getFieldDecorator } = this.props.form;
    
		return (
			<div className="boot-camp">
        <span style={{ display: 'flex', alignItems: 'center', fontSize: '18px', fontWeight: '600' }}>训练营管理</span>
				<Divider />
				<div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px' }}>
					<div>
						<Input allowClear value={name} style={{ width: '260px', height: '40px', marginRight: '20px' }} 
						placeholder="请输入训练营名称"
						onChange={(e)=>{
							e.persist()
							this.setState({
									name: e.target.value,
							})
						}}
						></Input>
            <Select placeholder="学科" value={subjectId} allowClear style={{ width: 140,  marginRight: '20px' }} onChange={(value) => {
								this.setState({
                  subjectId: value
								})
								}}>
									<Option value={""}>全部</Option>
									{this.state.subjectList.map(item => {
										return (<Option key={item.id + item.name} value={item.id}>{item.name}</Option>)
									})}
							</Select>
						<Button className='my-button-primary' type='primary' onClick={() => {
							this.bootList()
						}}>搜索</Button>
						<span style={{marginLeft: '20px'}} className='my-button-txt' onClick={() => {
							this.setState({
                  name: '',
                  subjectId: '',
                  pageNum: 1,
                  pageSize: 10,
							},()=>{
								this.bootList()
							})
						}}>重置</span>
					</div>
					<Button className='my-button-primary' type='primary' onClick={() => { this.showModal() }}>新增</Button>
				</div>
        <Table
          dataSource={bootListData}
          columns={columns}
          rowKey={record => record.id+''}
          rowClassName={(record, index) => (index % 2 !== 0 ? 'table-line' : '')}
          pagination={false}
				/>
        <Pagination className="table-pagination" showTotal={total => `共 ${total} 条`} total={total} current={pageNum} showSizeChanger pageSizeOptions={['10', '20', '50', '100']} onChange={this.pageChange} onShowSizeChange={this.sizeChange} />

        <Modal
					getContainer={false}
					title={modelTitle}
					okText="确认"
					cancelText="取消"
					visible={visible}
					onOk={() => { this.handleOk() }}
					onCancel={() => { this.setState({ visible: false }) }}
					destroyOnClose
					maskClosable={false}
          width={680}
				>
					<Form labelCol={{ span: 5 }} wrapperCol={{ span: 17 }} onSubmit={this.handleOk}>
						<FormItem label={"名称"}>
							{getFieldDecorator('name', {
								rules: [{ required: true, message: '请输入名称!' },{max: 50, message: '最多输入50个字符'}],
								initialValue:modelTitle==='编辑'? swiperName: ''
							})(
								<Input allowClear placeholder='请输入名称' />
							)}
						</FormItem>
            <FormItem label={"学科"}>
            {getFieldDecorator('subjectId', {
								rules: [{ required: true, message: '请选择学科名称!' }],
								initialValue:modelTitle==='编辑'? subjectform: ''
							})(
                <Select placeholder="学科" allowClear style={{ width: 140,  marginRight: '20px' }} >
                      {this.state.subjectList.map(item => {
                        return (<Option key={item.id + item.name} value={item.id}>{item.name}</Option>)
                    })}
                  </Select>
              )}
            </FormItem>
						<Form.Item label="封面图">
							{getFieldDecorator('poster', {
								initialValue: modelTitle==='编辑'? poster: '',
								rules: [{ type: 'object', required: true, message: '请上传封面图!' }],
							})(
									<UploadQiniu  getQiniuUrl={this.getQiniuUrl}/>
								
							)}
						</Form.Item>
            <Form.Item label="选择日期：">
            {getFieldDecorator("sleDate", {
              initialValue: modelTitle==='编辑'? [startDate, endDate]: [],
              rules: [{ required: true, message: "请选择开始时间！" }],
            })(
              <RangePicker
                showTime
                format="YYYY-MM-DD"
                placeholder="请选择" onChange={(date, dateString) => {
                  this.setState({
                    startDate: dateString[0],
                    endDate: dateString[1]
                  })
                }
             }
              />
            )}
          </Form.Item>
          <Form.Item label="开始时间：">
            {getFieldDecorator("startTime", {
              initialValue: modelTitle ==='编辑'? startTime:null,
              rules: [{ required: true, message: "请输入开始时间！" }],
            })(
              <TimePicker showTime format="HH:mm"  placeholder="请选择"  />
            )}
          </Form.Item>
          <Form.Item label="结束时间：">
            {getFieldDecorator("endTime", {
              initialValue: modelTitle === '编辑'? endTime: null,
              rules: [{ required: true, message: "请输入结束时间！" },{ validator: this.downValidateForm }],
            })(
              <TimePicker
                showTime
                format="HH:mm"
                placeholder="请选择"
              />
            )}
          </Form.Item>
          <FormItem label={"预设人数"}>
						{getFieldDecorator('presetNum', {
							initialValue: modelTitle === '编辑' ? presetNum : '',

						})(
							<InputNumber placeholder='请输入预设人数' precision={0} />
						)}
					</FormItem>
            <Form.Item label="课程介绍" style={{zIndex: '2'}}>
              {getFieldDecorator('introduce', {
                initialValue:modelTitle==='编辑'? introduce: ''
              })(
                 <Wangeditor content={introduce} getText={(e) => this.getText(e, 'introduce')} />
              )}
            </Form.Item>
            </Form>
            </Modal>
      </div>
    )
  }
}

export default Form.create()(BootCampet)